import React from 'react';
import Modal from '../Modal';
import ReactPlayer from 'react-player';
import BsInfoCircle from '@meronex/icons/bs/BsInfoCircle';

const VideoModal = ({ isVisible, setIsVisible, videoUrl }) => {
    return (
        <>
            
            <Modal
                className="w-[90vw] md:w-[55%] lg:w-[45%] md:h-[400px] lg:h-[400px]"
                visible={isVisible}
                onClick={() => setIsVisible(false)}
               
            >
                <ReactPlayer
                    url={videoUrl}
                    className="react-player"
                    light={false}
                    playing
                    width="100%"
                    height="100%"
                    controls={true}
                />
            </Modal>
        </>
    );
};

export default VideoModal;
